import { Sparkle } from "lucide-react";

const SPOTS = [
  { top: "12%", left: "6%", size: 16, delay: "0s" },
  { top: "28%", right: "8%", size: 20, delay: "1.2s" },
  { top: "62%", left: "12%", size: 14, delay: "2s" },
  { top: "70%", right: "14%", size: 18, delay: "0.6s" },
  { top: "45%", left: "46%", size: 12, delay: "2.6s" },
  { bottom: "10%", left: "30%", size: 15, delay: "1.7s" },
];

const Sparkles = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
    {SPOTS.map((s, i) => (
      <Sparkle
        key={i}
        size={s.size}
        className="animate-sparkle absolute text-[#D4AF37]"
        style={{ ...s, animationDelay: s.delay }}
        fill="currentColor"
      />
    ))}
  </div>
);

export default Sparkles;
